// Datums-/Zeitformatierung — überall lokal (Europe/Berlin). Locale-Argument
// optional, Default 'de-DE'. Admin nutzt immer den Default, Public reicht
// `localeFor(lang)` durch.

export function formatDate(iso: string, locale: string = 'de-DE'): string {
  // iso = "yyyy-mm-dd"
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatDateShort(iso: string, locale: string = 'de-DE'): string {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return iso;
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function formatDeadline(iso: string, locale: string = 'de-DE'): string {
  // iso = "yyyy-mm-ddTHH:MM" (lokal Berlin)
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(iso);
  if (!m) return iso;
  const [, y, mo, d, h, mi] = m;
  const date = new Date(Date.UTC(Number(y), Number(mo) - 1, Number(d)));
  const dateText = date.toLocaleDateString(locale, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
  const timeSuffix = locale.startsWith('de') ? ' Uhr' : '';
  return `${dateText}, ${h}:${mi}${timeSuffix}`;
}
